
import { ProductGroup } from "@/models/base/product-group";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppProductGroupSelect from "@/components/product-group/ProductGroupSelect.vue";

export default Vue.extend({
	data(){
		return {
			groups: [] as ProductGroup[],
			adding: false
		};
	},
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	methods: {
		cancel(){
			this.state.addProductsWithNotEnoughInStockBySelectedSupplierSelectGroupModalOpen = false;
		},
		async confirm(){
			if (this.adding) return;
			this.adding = true;
			try{
				await this.state.addProductsWithNotEnoughInStockBySelectedSupplier(this.groups.map(g=>g.ID));
				this.state.addProductsWithNotEnoughInStockBySelectedSupplierSelectGroupModalOpen = false;
			}catch(err){

			}finally{
				this.adding = false;
			}
		}
	},
	components: {
		AppProductGroupSelect
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
